import * as Sentry from '@sentry/react';

// Initialize Sentry error monitoring. Runs only in production and only when a DSN is provided
// via REACT_APP_SENTRY_DSN (a public client key — safe to bake into the bundle, like the
// Firebase web config). Scoped to error capture for beta: no performance tracing or session
// replay yet (keeps overhead + free-tier quota low). Complements the in-app clientErrorLogger
// (which drives the user-facing error banner) — this is for our monitoring/alerting.
let sentryEnabled = false;

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || process.env.NODE_ENV !== 'production') return false;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    // Errors only for now — no perf transactions.
    tracesSampleRate: 0,
    // Common browser noise that isn't actionable.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Non-Error promise rejection captured',
    ],
  });

  sentryEnabled = true;
  return true;
}

export function isSentryEnabled() {
  return sentryEnabled;
}

// Tag events with the Firebase uid so triage can distinguish "one user hit this 40 times"
// from "40 users hit it once". uid ONLY — no email or display name. Sentry stays free of PII,
// matching what backend/utils/safeLogger.js already redacts. Pass a falsy uid on sign-out.
export function setSentryUser(uid) {
  if (!sentryEnabled) return;
  Sentry.setUser(uid ? { id: uid } : null);
}
